export const actions = {
  set_state: 'affiliates/set_state',
  get_affiliates: 'affiliates/get_affiliates',
  get_affiliates_info: 'affiliates/get_affiliates_info'
}
